import React, { useMemo, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
  Alert,
} from '@mui/material';

export default function InterclubTermsDialog({ open, termsVersion, onAccept }) {
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const versionLabel = useMemo(() => termsVersion || 'current', [termsVersion]);

  const handleAccept = async () => {
    try {
      setSubmitting(true);
      await onAccept();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      fullWidth
      maxWidth="md"
      disableEscapeKeyDown
    >
      <DialogTitle>Interclub Admin Terms of Service</DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <Alert severity="info">
            You must accept these terms to continue. Version: {versionLabel}
          </Alert>

          <Typography variant="body2" color="text.secondary">
            By using the PNIC Scores platform as an interclub administrator, you agree to the following:
          </Typography>

          <Typography variant="body2" component="div">
            <strong>1. Service Use.</strong> You are authorized to manage competitions, settings,
            and payment configuration for your interclub only. You will not attempt to access data
            or settings for other interclubs without authorization.
          </Typography>

          <Typography variant="body2" component="div">
            <strong>2. Stripe Connect Payments.</strong> Payments are processed by Stripe on your
            connected account. PNIC Scores facilitates payment collection and may apply a platform
            fee per transaction. You are responsible for configuring your Stripe Connect account,
            completing onboarding, and ensuring your account details are accurate.
          </Typography>

          <Typography variant="body2" component="div">
            <strong>3. Fees & Refunds.</strong> Interclub administrators are responsible for their
            own fee policies and refund handling. PNIC Scores does not issue refunds on your behalf.
          </Typography>

          <Typography variant="body2" component="div">
            <strong>4. Data & Privacy.</strong> You will only use skater and parent data for the
            purposes of registration, competition administration, and reporting. You will protect
            credentials and follow all applicable privacy regulations.
          </Typography>

          <Typography variant="body2" component="div">
            <strong>5. Availability.</strong> The service is provided “as is” without guarantees of
            uninterrupted availability. We will make reasonable efforts to maintain service uptime.
          </Typography>

          <Typography variant="body2" component="div">
            <strong>6. Compliance.</strong> You agree to comply with US Figure Skating policies and
            any local or federal regulations applicable to your interclub operations.
          </Typography>

          <Typography variant="body2" component="div">
            <strong>7. Changes.</strong> Terms may be updated periodically. Continued use after an
            update constitutes acceptance of the revised terms.
          </Typography>

          <FormControlLabel
            control={<Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />}
            label="I have read and agree to the Interclub Admin Terms of Service."
          />

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              variant="contained"
              onClick={handleAccept}
              disabled={!checked || submitting}
            >
              {submitting ? 'Saving...' : 'Accept and Continue'}
            </Button>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
